module.exports = __webpack_public_path__ + "img/制御工学8_9.34d7a4b1.png";